import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Internet drama",
  "description": "",
  "published": "2007-06-27T00:00:00.000Z",
  "redirect_from": ["/blog/internet-drama/swizec/182"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The internet is vast and it is large, but most of all it's huge beyond comprehension. Today we are going to look into a very interesting aspect of internet life - drama. Just why exactly does it exist and why the hell is it even remotely tolerated?`}</p>
    <p>{`Well I have no idea, but I can tell you a little bit about it. Many people get very personal with online communities and that's good, it's very good in fact, but it can go a bit too far. For example when people leave for extended periods of time and then return, they mostly tend to announce their return with a thread and try making a big fuss about it. This isn't too bad, it shows them who's still available that they remember and it brings old friends together ... all around pretty decent.`}</p>
    <p>{`The really annoying ones are those who choose to publicly announce their leaving and try making it a big deal. Almost like "Look at me, I'm leaving because I don't like you all, now I want you all to cry over me even though I claim I will never check back again at all." Firstly, why would you need a thread that you're never checking again? Secondly why should we feel bad about loosing you? Clearly you don't like us and we probably don't like you either.`}</p>
    <p>{`A forum I'm frequenting lately is going through this right now. A person was being a total tart in the IRC channel, or so rumour has it, and it was so bad as to make the poor admin-lass claim she hates IRC all over and that it reminded her of why she hated people in the first place ... she isn't returning. The person got banned and then walced onto the forum, made a big triumphant post about leaving forever and eve, and that they blocked everyone from the board they had on MSN or any other IM. Yay, good for you mr. person, why are you telling us this again? Being an attention seeking spoilt brat are we?`}</p>
    <p>{`In conclusion, don't make internet drama, it makes you look like a twelve year old.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      